import { dateShortIn } from 'Data/format'

export function getDate(realDate, estimatedDate) {
  return !!realDate || !!estimatedDate
    ? dateShortIn(realDate || estimatedDate)
    : 'Not Defined'
}
